export default {"src":"/_next/static/media/attachments-icon.154da1e8.svg","height":512,"width":513};